"use client"

import { useCallback, useEffect, useState } from "react"
import useEmblaCarousel from "embla-carousel-react"
import Image from "next/image"

const testimonials = [
  {
    quote:
      "We struggled with a cluttered inventory management system, after implementing Odoo ERP into my business it completely transformed our operations and provided real- time visibility into stack level and order fulfillment.As a result, we've seen a significant increase in efficiency and customer satisfaction.",
    author: "Talya Deane",
  },
  {
    quote:
      "As a top construction company, we need custom modules to track project progress and manage resources.CodeTrade provides excellent Odoo development and implementation services, impressing us with their professionalism and expertise.",
    author: "Khaled Rokban",
  },
  {
    quote:
      "We migrated from a legacy system to a new Odoo ERP system designed for the healthcare industry with the help of CodeTrade Odoo experts.The new system has improved our inventory management, order fulfillment, and financial reporting.",
    author: "Jay Martin"
  },
  {
    quote: "Our previous accounting software couldn't handle our complex financial operations.The Odoo development team at CodeTrade customized the platform to meet our specific accounting needs and it improves financial reporting, automates workflows, and better control over our cash flow.",
    author: "Emmanuel Rodriguez",
  },
  {
    quote:
      "As a growing online jewelry business, we needed a strong and scalable ERP system to manage our orders, customers, and inventory.The Odoo development services provided by CodeTrade were an ideal solution.Since implementing Odoo, we have observed a substantial increase in customer satisfaction and order processing speed.",
    author: "Alex Partovi"
  },
  {
    quote:
      "CodeTrade India Pvt. Ltd. delivered a fully functional product that reduced staff requirements, increased stock availability across business networks, and a real- time data - driven routing system.The team was highly professional from a workflow standpoint, and internal stakeholders were impressed with the service provider's consistent accessibility.",
    author: "Bruce Campbell"
  },
  {
    quote:
      "I had the privilege of working closely with Codetrade on a Odoo ERP project that have a significant impact and I can confidently say their project management skills are second to none.Hardik has a unique combination of strategic vision, extreme attention to detail as well as exceptional leadership capabilities which are always instrumental in driving projects towards success.",
    author: "Mekelins International Trading Co LLC"
  },

]

const options = {
  align: "center",
  loop: true,
  dragFree: false,
}

export default function Testimonials() {
  const [emblaRef, emblaApi] = useEmblaCarousel(options)

  const [canScrollPrev, setCanScrollPrev] = useState(false)
  const [canScrollNext, setCanScrollNext] = useState(false)
  const [selectedIndex, setSelectedIndex] = useState(0)

  const onSelect = useCallback((api) => {
    setCanScrollPrev(api.canScrollPrev())
    setCanScrollNext(api.canScrollNext())
    setSelectedIndex(api.selectedScrollSnap())
  }, [])

  useEffect(() => {
    if (!emblaApi) return
    onSelect(emblaApi)
    emblaApi.on("select", onSelect)
    emblaApi.on("reInit", onSelect)
  }, [emblaApi, onSelect])

  const scrollPrev = useCallback(() => emblaApi && emblaApi.scrollPrev(), [emblaApi])
  const scrollNext = useCallback(() => emblaApi && emblaApi.scrollNext(), [emblaApi])

  return (
    <section className="relative bg-white py-16">
      <div className="container max-w-[1280px] mx-auto px-6">
        {/* Section Title */}
        <div className="text-center mb-12">
          <h2
            id="blogs"
            className="relative inline-block text-3xl md:text-4xl lg:text-5xl font-extrabold text-[#714b67] z-10"
          >
            What Our Clients Say {" "}

            <span className="relative inline-block">
              About Us
              <Image
                src="/icons/title.svg"
                alt="title-highlight"
                width={146}
                height={10}
                className="absolute right-0 bottom-[-14px] w-[146px] z-[-1]"
                placeholder='blur'
                blurDataURL="/svg-placeholder.jpg"
              />
            </span>
          </h2>
        </div>
        <div className="overflow-hidden" ref={emblaRef}>
          <div className="mx-[-12px] flex">
            {testimonials.map((t, idx) => (
              <div
                key={idx}
                className={`min-w-0 shrink-0 grow-0 basis-full px-3 md:basis-full lg:basis-1/3 transition-opacity duration-300 ${idx === selectedIndex ? "opacity-100" : "opacity-60"}`}
                aria-roledescription="slide"
                aria-label={`Slide ${idx + 1} of ${testimonials.length}`}
              >
                <TestimonialCard {...t} />
              </div>
            ))}
          </div>
        </div>

        <div className="pointer-events-none absolute inset-x-0 -bottom-7 flex items-center justify-center gap-4 sm:-bottom-9">
          <button
            type="button"
            aria-label="Previous testimonial"
            onClick={scrollPrev}
            disabled={!canScrollPrev && false}
            className="pointer-events-auto h-10 w-10 rounded-full bg-[#714b67] text-white shadow-lg hover:bg-[#7c5271] disabled:opacity-60 flex items-center justify-center"
          >
            <Image src="/icons/prev-icon.svg" alt="arrow-left" width={18} height={18} placeholder='blur' blurDataURL="/svg-placeholder.jpg" />
          </button>
          <button
            type="button"
            aria-label="Next testimonial"
            onClick={scrollNext}
            disabled={!canScrollNext && false}
            className="pointer-events-auto h-10 w-10 rounded-full bg-[#714b67] text-white shadow-lg hover:bg-[#7c5271] disabled:opacity-60 flex items-center justify-center"
          >
            <Image src="/icons/next-icon.svg" style={{ color: '#fff' }} alt="arrow-right" width={18} height={18} placeholder='blur' blurDataURL="/svg-placeholder.jpg" />
          </button>
        </div>
      </div>
    </section>
  )
}



function TestimonialCard({ quote, author, company, rating = 5 }) {
  return (
    <div className="h-full rounded-2xl border-0 bg-white p-8 shadow-[0_10px_30px_rgba(80,0,80,0.06)] ring-1 ring-gray-100">
      <div className="flex items-center justify-center gap-1" aria-label={`${rating} out of 5 stars`}>
        <Image src="/icons/rating.svg" alt="rating" height={48} width={120} placeholder='blur' blurDataURL="/svg-placeholder.jpg" />
      </div>

      <blockquote className="mt-6 text-center text-[15px] leading-7 text-gray-700">{quote}</blockquote>

      <div className="mt-8 text-center">
        <p className="text-base font-semibold tracking-tight text-gray-900">{author}</p>
        {company ? <p className="mt-1 text-sm font-medium text-gray-400">{company}</p> : null}
      </div>
    </div>
  )
}